import { InvestigationSidebar } from '@/components/investigations/InvestigationSidebar'
import { SidebarOpenButton } from '@/components/investigations/SidebarOpenButton'
import { PureTimelineView } from '@/components/pure-timeline/PureTimelineView'
import { useTimeAxisSidebar } from '@/features/cases/hooks/useTimeAxisSidebar'
import { useInvestigateEmptyStateProps } from '@/features/investigations/hooks/useInvestigateEmptyStateProps'
import { useInvestigationUrlSync } from '@/features/investigations/hooks/useInvestigationUrlSync'
import { useObjectSet } from '@/features/investigations/hooks/useObjectSet'
import { useCaseContext } from '../../CaseContext'

export default function TimeAxisPage() {
  const { caseId } = useCaseContext()
  const emptyStateProps = useInvestigateEmptyStateProps('timeline')
  useInvestigationUrlSync()
  // Sidebar visibility + the selection-driven force-open effect live in a
  // page-specific hook; this container only wires the open state into the
  // view's slots.
  const { sidebarOpen, setSidebarOpen } = useTimeAxisSidebar()
  const objectSet = useObjectSet()

  const showSidebar = objectSet.ids !== null

  // Pass the sidebar through PureTimelineView's `sidebarSlot` so it renders
  // inside the events canvas. That keeps the bottom TimeRangeFilter full-width
  // and stops the sidebar above it — matching the Geo view's layout.
  return (
    <div className="relative flex h-full min-h-0 w-full flex-col">
      <PureTimelineView
        caseId={caseId}
        emptyStateProps={emptyStateProps}
        sidebarSlot={
          showSidebar ? (
            <InvestigationSidebar
              caseId={caseId}
              view="timeline"
              open={sidebarOpen}
              onOpenChange={setSidebarOpen}
            />
          ) : null
        }
        topRightAccessory={
          showSidebar && !sidebarOpen ? (
            <SidebarOpenButton onClick={() => setSidebarOpen(true)} />
          ) : null
        }
        sidebarOpen={showSidebar && sidebarOpen}
      />
    </div>
  )
}
